<template>
  <div class="w-100">
    <div
      class="main-card d-flex p-a-16 align-items-center align-self-stretch justify-content-between"
      @click="$emit('click')"
    >
      <div
        class="its-texts d-flex flex-column align-items-start"
        style="gap: 8px"
      >
        <div class="d-grid align-items-center">
          <p class="f-Overpass f-16 f-w-600 my-0">{{ data.ref_id }}</p>
          <p class="f-Overpass f-12 f-w-400 my-0 f-c-grey">
            {{ this.$moment(data.date).format("L") }}
          </p>
        </div>
        <div class="d-flex align-items-center" style="gap: 4px">
          <img src="../../../assets/icons/location.svg" alt="time" />
          <p class="f-Overpass f-12 f-w-400 mt-1 my-0 f-c-grey">
            {{ data.outlet }}
          </p>
        </div>
      </div>

      <div
        class="d-flex flex-column justify-content-between align-items-center"
      >
        <p
					class="f-Overpass f-16 f-w-400 my-0 "
					:class="data.value > 0 ? 'f-c-green' : 'f-c-red'"
				>
          {{ formatCurrency(data.value) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "riwayatCard",
  props: {
    data: {
			type: Object,
			default: () => {},
		}
  },
  computed: {
    ...mapState("riwayat", {
      detailEmoney: "detailEmoney",
    }),
  },
  methods: {
    ...mapActions({
      getDetailTopUp: "riwayat/getDetailTopUp",
    }),
  },
};
</script>

<style scoped>
.main-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  margin-top: 16px;
}
</style>
